<script setup>
const props = defineProps({
	title: {
		type: String,
		required: true
	},
	featuredImage: {
		type: String,
		default: null
	},
	authorName: {
		type: String,
		default: "Timothy Sykes"
	},
	formattedDate: {
		type: String,
		required: true
	},
	reviewerName: {
		type: String,
		default: null
	},
	factCheckerName: {
		type: String,
		default: null
	}
});

const generateBioPageLink = (name) => {
	let url = name.includes("-")
		? name.replace("-", " ").split(" ").join("-")
		: name.split(" ").join("-");

	url = url === "Timothy-Sykes" ? "tim-sykes" : url;

	const pages = [
		"bohen-bot",
		"ed-weinberg",
		"friedrich-odermann",
		"jordan-s",
		"stephanie-thompson",
		"tim-bohen",
		"tim-bot",
		"tim-sykes",
		"timothysykes",
		"ben-sturgill",
		"bryce-tuohey",
		"matt-monaco",
		"jeff-zananiri",
		"ellis-hobbs",
		"jack-kellogg"
	];

	if (!pages.includes(url.toLocaleLowerCase())) {
		url = "tim-sykes";
	}

	return `/blog/author/${url.toLowerCase()}/`;
};
</script>

<template>
	<section class="news-hero">
		<div class="news-hero__image-wrapper">
			<img
				v-if="featuredImage"
				:src="featuredImage"
				:data-src="featuredImage"
				:alt="`${title} Thumbnail`"
				class="news-hero__image"
			/>
			<div
				v-else
				class="news-hero__image-placeholder"
			/>
			<div class="news-hero__gradient" />
		</div>

		<!-- News Source Buttons -->
		<div class="news-hero__sources">
			<a
				href="https://news.google.com/publications/CAAqBwgKMJbmngswsvC2Aw?hl=en-US&gl=US&ceid=US%3Aen"
				target="_blank"
				rel="noopener noreferrer"
				class="news-hero__source-btn news-hero__source-btn--stacked"
			>
				<span class="news-hero__source-label lg:inline-flex hidden">
					ADD US ON
				</span>
				<span class="news-hero__source-row">
					<span class="news-hero__source-google">G</span>
					Google News
				</span>
			</a>
		</div>

		<!-- Hero Content Overlay -->
		<div class="news-hero__content">
			<h1
				class="news-hero__title"
				v-html="title"
			/>

			<div class="news-hero__meta">
				<NuxtLink
					:to="generateBioPageLink(authorName)"
					class="news-hero__author"
				>
					{{ authorName.toUpperCase() }}
				</NuxtLink>
				<span class="news-hero__meta-dot">&bull;</span>
				<span class="news-hero__date">UPDATED {{ formattedDate }}</span>
			</div>

			<div
				v-if="reviewerName || factCheckerName"
				class="news-hero__reviewers"
			>
				<span
					v-if="reviewerName"
					class="news-hero__reviewer"
				>
					<svg
						class="news-hero__check-icon"
						width="14"
						height="14"
						viewBox="0 0 14 14"
						fill="none"
					>
						<circle
							cx="7"
							cy="7"
							r="7"
							fill="white"
						/>
						<path
							d="M4 7l2 2 4-4"
							stroke="black"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
					Reviewed by
					<NuxtLink
						:to="generateBioPageLink(reviewerName)"
						class="news-hero__reviewer-link"
					>
						{{ reviewerName }}
					</NuxtLink>
				</span>
				<span
					v-if="factCheckerName"
					class="news-hero__reviewer"
				>
					<svg
						class="news-hero__check-icon hidden lg:inline-flex"
						width="14"
						height="14"
						viewBox="0 0 14 14"
						fill="none"
					>
						<circle
							cx="7"
							cy="7"
							r="7"
							fill="white"
						/>
						<path
							d="M4 7l2 2 4-4"
							stroke="black"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
					<span class="lg:hidden">and</span>
					Fact-checked by
					<NuxtLink
						:to="generateBioPageLink(factCheckerName)"
						class="news-hero__reviewer-link"
					>
						{{ factCheckerName }}
					</NuxtLink>
				</span>
			</div>
		</div>
	</section>
</template>
